import { proxy } from 'valtio';
import { deepClone } from 'valtio/utils';
import { computed } from 'valtio-reactive';

import {
    DiagramComment,
    DiagramComponentInstance,
    DiagramConnection,
    DiagramGroup,
    DiagramInfoBlock,
    DiagramImage,
    DiagramTextarea,
    Point,
} from 'models';

type SelectionItem =
    | {
          type: 'component-instance';
          id: DiagramComponentInstance['id'];
      }
    | {
          type: 'connection';
          id: DiagramConnection['id'];
      }
    | {
          type: 'group';
          id: DiagramGroup['id'];
      }
    | {
          type: 'infoBlock';
          id: DiagramInfoBlock['id'];
      }
    | {
          type: 'image';
          id: DiagramImage['id'];
      }
    | {
          type: 'textarea';
          id: DiagramTextarea['id'];
      }
    | {
          type: 'comment';
          id: DiagramComment['id'];
      };

type SelectionState = {
    selection: SelectionItem[];
};

const selectionStateDefaults: SelectionState = {
    selection: [],
};

const state = proxy(deepClone(selectionStateDefaults));

const derived = computed({
    getSelectedIds: () => {
        const array = state.selection.map((item: SelectionItem) => item.id);

        return array.reduce((object: { [key: string]: boolean }, id) => {
            object[id] = true;

            return object;
        }, {});
    },
    getOnlySelectedId: () => {
        const selection = state.selection;

        return selection.length === 1 ? selection[0].id : null;
    },
});

const selectionViewfinderState = proxy({
    start: null as Point | null,
    end: null as Point | null,
    executed: false,
});

export { selectionViewfinderState, state, derived, selectionStateDefaults };
export type { SelectionItem };
